$(document).ready(function(){
	$('.content-tip').hover(function() {
		// Pega o valor do atributo data-target
		var target = $(this).attr('data-target');

		// Encontra o elemento com o mesmo data-target e alterna a classe
		$('[data-target="'+target+'"]').toggleClass('highlight-tip-active');
	});

	$('#disable-tips').click(function(){
		$('.content-tip').toggleClass('d-none');
	}); 

	$('.content-lock .content-link').on('click', function(e) {
        e.preventDefault();
        $('#login-modal').modal('show');

        var loginUrl = $('.btn-login-user-modal').attr('href');
        var targetUrl = $(this).attr('href');

        $('.btn-login-user-modal').attr('href', loginUrl + '?redirect_to=' + targetUrl);
    });
});